import {
  Box,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  Text,
  VStack,
  Heading,
} from "@chakra-ui/react";

import Button from "../../Button/Button";

// import { ReactComponent as VerificationBadgeIcon } from "assets/svg/verification-badge.svg";

import { ReactComponent as WarnIcon } from "assets/icons/warn.svg";

const VirtualCardLimitSupport = ({ isOpen, onClose }) => {
  const handleClick = () => {
    // history.push("/dashboard/account/verification");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent
        maxW={380}
        bg="var(--primary)"
        isCentered
        fontFamily="var(--poppins)"
        borderRadius="24px"
        h="fit-content"
        // #03A438
      >
        <ModalCloseButton />
        <ModalBody>
          <Box as={VStack} pt="20px" textAlign="center" color="white">
            <Box as={WarnIcon} boxSize="100px" mb="20px" />
            <Heading
              fontSize="xl"
              fontWeight="500"
              fontFamily="var(--poppins)"
              letterSpacing="-1px"
            >
              Virtual Card
            </Heading>
            <Text
              m="0"
              color="white"
              //   color="#4E4B66"
              fontFamily="var(--poppins)"
              letterSpacing="-1px"
              fontWeight="500"
            >
              We currently do not support virtual cards for your country. Kindly
              explore other Bitmama features
            </Text>
          </Box>

          <VStack pt="32px" pb="48px">
            <Button
              onClick={handleClick}
              minW="fit-content"
              minH="fit-content"
              size="sm"
              bg="white"
              color="var(--primary)"
              variant="ghost"
            >
              Close
            </Button>
          </VStack>
        </ModalBody>

        {/* <ModalFooter as={HStack} justify="flex-end">
          <Button
            onClick={onClose}
            minW="100%"
            size="sm"
            color="white"
            variant="ghost"
          >
            Close
          </Button>
        </ModalFooter> */}
      </ModalContent>
    </Modal>
  );
};

export default VirtualCardLimitSupport;
